export enum TreatmentFileKind {
  Original = 0,
  Design = 1,
  Other = 2,
  Revision = 3,
  ImprovedOriginal = 4,
}
